// Packages
import debounce from 'lodash/debounce';
import SplitType from 'split-type';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Media
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// TEXT ANIMATION
//
export default function initTextAnimation(selector, fromMedia = undefined) {
  if (!selector) {
    return false;
  }

  const text = new SplitType(selector, { types: 'lines' });
  const resizeObserver = new ResizeObserver(
    debounce(() => {
      if (!fromMedia || fromMedia.matches) {
        text.split(undefined);

        handleTextAnimation();
      } else {
        text.revert();
      }
    }, 100)
  );

  const textElement = document.querySelector(selector);
  resizeObserver.observe(textElement);

  const handleTextAnimation = () => {
    const lines = document.querySelectorAll('.line');

    lines.forEach((line, index) => {
      const words = line.querySelectorAll('span');

      const previousLineHeight = index > 0 ? lines[index - 1].offsetHeight : 0;

      words.forEach((word, index) => {
        scrollAnimationProgress(word, {
          getStart(el) {
            const delayStep = mediaSm.matches ? 10 : 30;
            const delay = index === 0 ? 0 : delayStep * index;
            const elCount = previousLineHeight;
            const elHeight = el.offsetHeight + elCount;
            const rect = el.getBoundingClientRect();

            return rect.top + window.scrollY - window.innerHeight + elHeight + delay + (mediaSm.matches ? 200 : 0);
          },
          getEnd(el, start) {
            let elHeight = el.offsetHeight;
            return start + elHeight;
          },
        });
      });
    });
  };
}
